import { concatAxiosTransformer } from '../helper';
export default class Warinigs {
    constructor(client) {
        this.client = client;
    }
    GetAll() {
        return this.client.get(`/warnings`, {
            transformResponse: concatAxiosTransformer(this.client.defaults.transformResponse, (warnings) => {
                for (const warning of warnings) {
                    for (const controllerWarning of warning.warnings) {
                        controllerWarning.time = new Date(controllerWarning.time);
                    }
                }
                return warnings;
            }),
        });
    }
}
